import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import { checkEmptyObject } from 'utils/functionality';
import { getConfig } from 'config/runtime';

const baseUrl = getConfig('REACT_APP_IMAGES');

const SelectFieldVehicleCategory = ({
  id,
  label,
  className,
  style,
  disable,
  placeholder,
  data,
  selectedCategory = [],
  onSelectCategory,
  onSearchAction,
  categoryValue,
}) => {
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  const [isShowDropdown, setIsShowDropdown] = useState(false);

  const [filteredData, setfilteredData] = useState([]);

  // SET FILTERED DATA BASE ON DATA
  useEffect(() => {
    if (!data || checkEmptyObject(data) || data?.category?.length === 0) return;

    let choosedIds = [];
    for (let choosedData of selectedCategory) {
      choosedIds.push(choosedData.id);
    }

    const checkedData = [...data.category].map((item) => ({
      ...item,
      checked: choosedIds.some((id) => id === item.id),
    }));
    setfilteredData(checkedData);
  }, [data, selectedCategory]);

  // CLICK OUTSIDE
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsShowDropdown(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // DROPDOWN SHOW FUNCTION
  const toggleDropdown = () => {
    setIsShowDropdown(!isShowDropdown);
  };

  // CHOOSE CAR FUNCTION
  const handleChooseVehicle = (e) => {
    const newFilteredData = [...filteredData];

    const checkedCategory = newFilteredData?.find((item) => item.id == e.target.value);
    checkedCategory.checked = e.target.checked;

    setfilteredData(newFilteredData);

    // if checked true
    if (e.target.checked) {
      onSelectCategory([...selectedCategory, checkedCategory]);
    } else {
      // if checked false
      const copyChoosedVehicle = [...selectedCategory];
      const newChoosedVehicle = copyChoosedVehicle.filter((item) => item.id !== checkedCategory?.id);
      onSelectCategory(newChoosedVehicle);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setIsShowDropdown(true);
    onSearchAction(value);
  };

  return (
    <div className={clsx('select-field-vehicle-category', className)} style={style} ref={dropdownRef}>
      {label && (
        <label htmlFor={id} className="select-field-vehicle-category__label">
          {label}
        </label>
      )}
      <div
        className={clsx('select-field-vehicle-category__field', disable ? 'disable' : '')}
        onClick={toggleDropdown}
        style={{ width: '100%', overflowX: 'auto' }}
      >
        {isShowDropdown ? (
          <input
            ref={inputRef}
            className="select-field-vehicle-category__field__input"
            id={id}
            placeholder={placeholder}
            value={categoryValue}
            onChange={handleInputChange}
            readOnly={disable}
            autoFocus
          />
        ) : selectedCategory?.length !== 0 ? (
          <div className="select-field-vehicle-category__field__car">
            {selectedCategory?.map((item, i) => (
              <span className={'name'} key={Math.random() + i}>
                <p>
                  {item.name}{' '}
                  <span>
                    {item.vehicle_names && item.vehicle_names?.length !== 0
                      ? `(${item.vehicle_names?.join(', ')})`
                      : null}
                  </span>
                </p>
              </span>
            ))}
          </div>
        ) : (
          <input
            ref={inputRef}
            className="select-field-vehicle-category__field__input"
            id={id}
            placeholder={placeholder}
            value={categoryValue}
            onChange={handleInputChange}
            readOnly={disable}
          />
        )}
      </div>

      {/* drop down */}
      {isShowDropdown && (
        <ul className="select-field-vehicle-category__dropdown">
          {filteredData?.length !== 0 && filteredData ? (
            filteredData.map((item, idx) => (
              <label key={idx} htmlFor={`option-${item.id}`}>
                <div>
                  {item.vehicle?.photo && item.vehicle?.photo?.length !== 0 && (
                    <img src={`${baseUrl}${item.vehicle.photo[0]?.name}`} alt={item.name} loading="lazy" />
                  )}
                </div>
                <div>
                  <h3>{item.name}</h3>
                  <p>
                    {item.vehicle_names && item.vehicle_names?.length !== 0
                      ? `(${item.vehicle_names?.join(', ')})`
                      : null}
                  </p>
                </div>
                <div className={item.checked ? 'check' : ''}>
                  <input
                    type="checkbox"
                    id={`option-${item.id}`}
                    checked={item.checked}
                    onChange={handleChooseVehicle}
                    value={item.id}
                    disabled={disable}
                    className="select-field-vehicle-category__checkbox"
                  />
                </div>
              </label>
            ))
          ) : (
            <li className="select-field-vehicle-category__not-found">Data Not Found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SelectFieldVehicleCategory;
